import { Fragment, startTransition, useEffect, useReducer, useState } from "react"
import parse from 'html-react-parser';
import useFetch from "../../../hook/useFetch";
import useFilter from '../../../hook/useFilter'
import { useDispatch, useSelector } from "react-redux";
import $ from 'jquery'
import ToggleButton from "../../ToggleButton";
import { Link, redirect, useNavigate } from "react-router-dom";
import { notificationActions } from "../../../store/notification-slice";
import InfoIcon from "../../InfoIcon";
import { faAdd, faClose, faPhotoFilm } from "@fortawesome/free-solid-svg-icons";

import Modal from "../../Modal";
import { backdropActions } from "../../../store/backdrop-slice";
import Gallery from "../../gallery";



export default function NewProduct({ product }) {



    let componentReducer = (state, action) => {

        switch (action.type) {
            case 'title':
                return { ...state, title: action.data }

            case 'ldescription':
                return { ...state, ldescription: action.data }
            case 'sdescription':
                return { ...state, sdescription: action.data }
            case 'start':
                return { ...state, start: action.data }
            case 'end':
                return { ...state, end: action.data }
            case 'image':
                return { ...state, image: action.data, imagepreview: URL.createObjectURL(action.data) }
            case 'price':
                return { ...state, price: action.data }
            case 'currency':
                return { ...state, currency: action.data }
            case 'addtag':
                if(state.tags.indexOf(action.data)!==-1){
                    return state
                }
                return { ...state, tags: [...state.tags, action.data] }

            case 'removetag':

                let updatedtags = state.tags
                updatedtags = updatedtags.filter((tag) => tag !== action.data)

                return { ...state, tags: updatedtags }

            case 'active':
                return { ...state, active: action.data }

            case 'ptype':
                return { ...state, ptype: action.data }
            case 'imagepreview':
                return { ...state, imagepreview: action.data }
            case 'identifier':
                return { ...state, identifier: action.data }


        }

    }

    const [componentState, componentDispatch] = useReducer(componentReducer, {

        title: product ? product.title : null,
        ldescription: product ? product.description : null,
        sdescription: product ? product.short_description : null,
        start: product ? product.start : null,
        end: product ? product.end : null,
        image: null,
        price: product ? product.price : null,
        currency: product ? product.currency : null,
        tags: product ? product.tags : [],
        active: product ? product.active : 1,
        ptype: product ? product.product_type_id : null,

        imagepreview: product ? product.image : null,
        identifier: product && product.identifier ? product.identifier : null

    })


    const { post, error, get, update } = useFetch()

    const [tags, setTags] = useState()

    const [currencies, setCurrencies] = useState()

    const [ptypes, setPtypes] = useState()

    const [images, setImages] = useState()

    const { convertToArray } = useFilter()

    let token = useSelector(state => state.user.token)

    let dispatch = useDispatch()

    let navigate = useNavigate()


    const modalReducer = (state, action) => {

        switch (action.type) {
            case 'show':
                return { ...state, show: !state.show }

            case 'data':
                return { ...state, data: action.data }

        }
    }
    console.log(tags)
    const [modalstate, modaldispatch] = useReducer(modalReducer, {
        show: false,
        data: null
    })

    useEffect(() => {
        get(`/admin/tags?token=${token}`, null, null, (data) => {
            data = convertToArray(data)
            let update = data.filter(tag => componentState.tags.indexOf(tag.tag) === -1)
            setTags(update)
        })

        get(`/admin/currencies?token=${token}`, null, null, (data) => {
            data = convertToArray(data)
            setCurrencies(data)

        })

        get(`/admin/producttypes?token=${token}`, null, null, (data) => {
            data = convertToArray(data)
            setPtypes(data)

        })



    }, [])



    let currencyOptions = []

    if (currencies) {
        Object.keys(currencies).forEach(key => {
            currencyOptions.push(<option key={key} value={key} >{currencies[key]}</option>)
        })
    }


    return <div className="edit-container" >
        {error &&
            <div className="alert bg-danger " >
                <p>{parse(error)}</p>
            </div>
        }
        <form className="edit-form bg-white grid-container-2-col" onKeyDown={(e) => {
           if(e.key==='Enter'){
            e.preventDefault()
           }
        }} onSubmit={(e) => {
            e.preventDefault()

            if (product) {

                update(`/admin/product?token=${token}&id=${product.id}`, componentState, (data) => {
                    dispatch(notificationActions.setNotification({
                        status: false,
                        message: data
                    }
                    ))
                }, (data) => {

                    dispatch(notificationActions.setNotification({
                        status: true,
                        message: data
                    }
                    ))

                    navigate('/admin/products', {
                        state: {
                            refetch: true
                        }
                    })
                })

                return
            }

            post(`/admin/product?token=${token}`, componentState, (data) => {
                dispatch(notificationActions.setNotification({
                    status: false,
                    message: data
                }
                ))
            }, (data) => {
                console.log(data)
                dispatch(notificationActions.setNotification({
                    status: true,
                    message: data
                }
                ))

                navigate('/admin/products', {
                    state: {
                        refetch: true
                    }
                })
            })
        }} >



            <div className="left-col" >
                <div className="form-group">
                    <label>Title</label>
                    <input type="text" className="form-control" placeholder="title" defaultValue={componentState.title} onInput={(e) => {
                        componentDispatch(
                            {
                                type: 'title',
                                data: e.target.value
                            }
                        )
                    }} required />

                </div>

                <div className="form-group">
                    <label >Description</label>
                    <textarea className="form-control" placeholder="long description" defaultValue={componentState.ldescription} onInput={(e) => {
                        componentDispatch(
                            {
                                type: 'ldescription',
                                data: e.target.value
                            }
                        )
                    }} />


                </div>


                <div className="form-group">
                    <label >ShortDescription</label>
                    <textarea className="form-control" placeholder="short description" defaultValue={componentState.sdescription} onInput={(e) => {
                        componentDispatch(
                            {
                                type: 'sdescription',
                                data: e.target.value
                            }
                        )
                    }} />

                </div>



                <div className="form-group">
                    <label >Image</label>
                    <input type="file" accept=".jpg, .jpeg, .png" className="form-control" defaultValue={componentState.image} onChange={(e) => {

                        if (!e.target.files[0]) {
                            return
                        }
                        componentDispatch(
                            {
                                type: 'image',
                                data: e.target.files[0]
                            }
                        )
                    }} />

                </div>

                <button className="btn btn-outline-secondary" type="button" onClick={() => {
                    get(`/admin/images?token=${token}`, null, null, (data) => {
                        data = convertToArray(data)
                        setImages(data)
                        modaldispatch({
                            type: 'data',
                            data: {
                                body: <Gallery images={data} onDoubleClick={(image) => {
                                    componentDispatch({
                                        type: 'identifier',
                                        data: image.identifier
                                    })
                                    componentDispatch({
                                        type: 'imagepreview',
                                        data: image.path
                                    })
                                    modaldispatch({
                                        type: 'show'
                                    })
                                    dispatch(backdropActions.toggleBackdrop())
                                }} />
                            }
                        })
                        modaldispatch({
                            type: 'show'
                        })
                        dispatch(backdropActions.toggleBackdrop())

                    })
                }} ><InfoIcon icon={faPhotoFilm} size='xl' />GALLERY</button>

                {componentState.imagepreview &&
                    <div className="form-group" >
                        <img className="card-img-top" src={componentState.imagepreview} alt={componentState.title} style={{ width: '100%', height: '100%' }} />
                    </div>
                }
            </div>
            <div className="right-col" >

                <div className="form-group">
                    <label >Start</label>
                    <input type="date" className="form-control" defaultValue={componentState.start} onInput={(e) => {
                        componentDispatch(
                            {
                                type: 'start',
                                data: e.target.value
                            }
                        )
                    }} />

                </div>

                <div className="form-group">
                    <label >End</label>
                    <input type="date" className="form-control" defaultValue={componentState.end} onInput={(e) => {
                        componentDispatch(
                            {
                                type: 'end',
                                data: e.target.value
                            }
                        )
                    }} />

                </div>

                <div className="form-group">
                    <label>Price</label>
                    <input type="number" className="form-control" placeholder="price" defaultValue={componentState.price} onInput={(e) => {
                        componentDispatch(
                            {
                                type: 'price',
                                data: e.target.value
                            }
                        )
                    }} />

                </div>

                <div className="form-group" >

                    <ToggleButton onToggle={(e) => {

                        componentDispatch(
                            {
                                type: 'active',
                                data: !componentState.active
                            }
                        )
                    }}
                        id='productactive'
                        label='Active'
                        defaultChecked={componentState.active}
                    />

                </div>

                {ptypes && <div className="form-group" >

                    <div className="grid-container-2-col" >
                        <select className="form-control" defaultValue={componentState.ptype} onChange={(e) => {
                            componentDispatch(
                                {
                                    type: 'ptype',
                                    data: e.target.value
                                }
                            )
                        }} >
                            <option value='' >ProductType</option>
                            {

                                ptypes.map(ptype => <option key={ptype.id} value={ptype.id} >{ptype.title}</option>)
                            }

                        </select>
                        <Link className="btn btn-outline-secondary" to='/admin/producttype' state={{
                            redirect: '/admin/newproduct'
                        }} >NewProductType</Link>
                    </div>

                </div>}
                <div className="form-group" >
                    <input className="form-control" placeholder="enter new tag press Enter"
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                componentDispatch({
                                    type: 'addtag',
                                    data: e.target.value
                                })

                            }
                        }}
                        type="text"
                    />
                </div>
                <div style={{ display: 'flex',flexWrap:'wrap' }} >
                    {
                        componentState.tags.map(tag => <div key={tag} className="shadow rounded" style={{ width: 100, padding: 5, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} >
                            {tag}

                            <InfoIcon size='xs' icon={faClose} style={{ cursor: 'pointer' }} onClick={() => {

                                componentDispatch({
                                    type: 'removetag',
                                    data: tag
                                })

                                let update = [...tags, { tag: tag }]

                                setTags(update)

                            }} />

                        </div>)
                    }
                </div>

                {
                    tags && <div style={{ display: 'flex',flexWrap:'wrap' }} >
                        {
                            tags.map(tag => <div key={tag.tag} className="shadow rounded" style={{ width: 100, padding: 5, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} >
                                {tag.tag}

                                <InfoIcon size='xs' style={{ cursor: 'pointer' }} icon={faAdd} onClick={() => {

                                    componentDispatch({
                                        type: 'addtag',
                                        data: tag.tag
                                    })

                                    let update = tags.filter(utag => utag.tag !== tag.tag)

                                    setTags(update)

                                }} />

                            </div>)
                        }
                    </div>
                }



                {currencies && <div className="form-group" >

                    <select className="form-control" defaultValue={componentState.currency} onChange={(e) => {
                        componentDispatch(
                            {
                                type: 'currency',
                                data: e.target.value
                            }
                        )
                    }} >
                        <option value='' >Currency</option>
                        {

                            currencyOptions
                        }

                    </select>
                </div>}


                <button type="submit" className="btn btn-primary"  >{product ? 'UPDATE' : 'REGISTER'}</button>
            </div>
        </form>

        {images && modalstate.show && modalstate.data && <div className="gallery" >
            <Modal body={modalstate.data.body} hideCopy={true} onClose={() => {
                modaldispatch({
                    type: 'show'
                })
                dispatch(backdropActions.toggleBackdrop())
            }} />
        </div>}


    </div>
}

